import React from "react";
import styled from "styled-components";
import { StickyContainer, Sticky } from "react-sticky";
import { Overlay, InsiderPhoto } from "components/common/candidate";
import {
  Rating,
  Tags,
  Sidebar,
  Button,
  Reviews,
  // Section,
  Objective,
  BackTo,
  FixedHeader
} from "./components";
import * as mixpanel from "core/integrations/mixpanel";
import * as fbPixel from "core/integrations/fb_pixel";
import * as dataLayer from "core/integrations/gtm";
import { ButtonRound } from "components/generic/kit";
import caretRight from "./assets/caret-right.svg";
import { Textarea } from "components/generic/form/native";

export default ({
  insider,
  isAuthenticated,
  subObjectives,
  mainObjective,
  onChooseTime,
  additionalNotes,
  setAdditionalNotes,
  onMainObjectiveChange,
  onSubObjectiveChange,
  handleTextChange,
  consultation
}) => (
  <StickyContainer>
    <Overlay classNameHeader="flex-ns dn">
      {window.innerWidth > 768 && (
        <Sticky topOffset={100}>
          {({ style, isSticky }) =>
            isSticky ? (
              <div style={style} className="w-100 z-max">
                <FixedHeader insider={insider} consultation={consultation} />
              </div>
            ) : (
              <div />
            )
          }
        </Sticky>
      )}
      <BackTo />
      <Container>
        <TopWrap>
          <div>
            <Position>
              {consultation
                ? "15 Minute Consultation ($10)"
                : `${insider.title}  ($${insider.call_price.current})`}
            </Position>
            <Subtitle>
              {consultation
                ? "With The Lobby Team"
                : insider.group_tag
                  ? insider.group_tag.label
                  : insider.company.name}
            </Subtitle>
          </div>
          {!consultation && (
            <div className="ml-auto flex-shrink-0 db-ns dn">
              <InsiderPhoto
                photo={insider.company.logo}
                alt={insider.display_name || insider.slug}
              />
            </div>
          )}
        </TopWrap>
      </Container>
      <Body>
        <Container>
          <ButtonWrap>
            <Button href="#objectives">
              <span>Schedule a call</span>
              <img
                className="dn-ns db flex-end"
                src={caretRight}
                alt="Schedule a call"
              />
            </Button>
          </ButtonWrap>
          <Content>
            <div className="flex-auto">
              {insider && <Resume>{insider.resume}</Resume>}
              {!consultation && (
                <div className="mt3">
                  <Experience>Experience</Experience>
                  <Tags items={insider.experience} />
                </div>
              )}
              <div id="objectives" className="mb4">
                <Objective
                  subObjectives={subObjectives}
                  onMainObjectiveChange={onMainObjectiveChange}
                  onSubObjectiveChange={onSubObjectiveChange}
                />
              </div>
              <Wrap className="mb4">
                <Textarea
                  placeholder="Type additional Notes (Optional)"
                  rows="6"
                  value={additionalNotes}
                  onChange={e => setAdditionalNotes(e.target.value)}
                />
              </Wrap>
              <div className="mb5 tl-ns tc">
                <ButtonRound
                  onClick={() => {
                    onChooseTime();
                    fbPixel.fbq("trackCustom", "ScheduleCall");
                    dataLayer.push({
                      event: "ScheduleCall"
                    });
                    mixpanel.trackEvent(
                      "Choose time to scheduling page clicked"
                    );
                  }}
                  disabled={!(mainObjective && subObjectives.length)}
                >
                  <span>Choose a time</span>
                  <img
                    className="dn-ns db flex-end"
                    src={caretRight}
                    alt="Choose a time"
                  />
                </ButtonRound>
              </div>
              {!consultation && (
                <div className="ml-auto flex-shrink-0 db-ns dn">
                  <Rating
                    n={insider.rate.number_of_reviews}
                    value={insider.rate.value}
                  />
                </div>
              )}
              {!consultation && <Reviews items={insider.reviews} />}
            </div>
            <Sidebar />
          </Content>
        </Container>
      </Body>
    </Overlay>
  </StickyContainer>
);

const Experience = styled.h4`
  margin: 0;
  color: #a1a19f;
  font-size: 1.75rem;
  font-family: "CircularStd-Book", sans-serif;
  margin-bottom: 0.65rem;
  @media (max-width: 680px) {
    font-size: 1.3rem;
  }
`;

const Wrap = styled.div`
  box-shadow: 15px 15px #ebe8e1;
  @media (max-width: 680px) {
    box-shadow: unset;
  }
`;
const ButtonWrap = styled.div`
  ${Button} {
    margin-top: -1rem;
  }
  @media (max-width: 680px) {
    text-align: center;
  }
`;

const Resume = styled.div`
  font-family: "CircularStd-Book", sans-serif;
  font-size: 28px;
  color: #333333;
  @media (max-width: 680px) {
    font-size: 23px;
    padding: 10px;
    text-align: center;
  }
`;
const Info = styled.div`
  font-size: 1.5rem;
  font-family: "CircularStd-Book", sans-serif;
  margin-bottom: 3.75rem;
`;

const Body = styled.div`
  width: calc(100% - 20px);
  margin: 0 auto;
  background-color: #f9f7f2;
  @media (max-width: 768px) {
    background-color: #f9f7f2;
  }
`;

const Content = styled.div`
  padding-top: 4.1875rem;
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

const Container = styled.div`
  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
`;

const TopWrap = styled.div`
  margin-top: 5rem;
  margin-bottom: 4.8rem;
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
  @media (max-width: 680px) {
    margin: unset;
    padding: 2rem 0;
    background-color: #f9f7f2;
  }
`;

const Position = styled.div`
  font-size: 2.75rem;
  font-family: TiemposHeadlineWeb;
  font-weight: 400;
  @media (max-width: 680px) {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 1rem;
  }
`;

const Subtitle = styled.div`
  font-size: 1.75rem;
  font-family: "CircularStd-Book", sans-serif;
  color: #908f8d;
  @media (max-width: 680px) {
    font-size: 1.2rem;
    text-align: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/View.js